import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

const InvalidResetLink = () => {
  const { theme } = useThemeConfig();

  return (
    <div className="text-center">
      <h2
        className="text-xl font-semibold mb-2"
        style={{ color: theme.sectionTitleColor }}
      >
        Link non valido o scaduto
      </h2>
      <p className="mb-4" style={{ color: theme.sectionTextColor }}>
        Richiedi un nuovo link per reimpostare la password.
      </p>
      <div className="flex flex-col gap-2">
        <Button
          className="w-full"
          style={{
            backgroundColor: theme.primaryColor || '#4caf50',
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding,
            transitionDuration: theme.transitionSpeed || '0.2s'
          }}
          asChild
        >
          <Link to="/login">Torna al login</Link>
        </Button>
        <Button
          className="w-full"
          variant="outline"
          style={{
            borderColor: theme.primaryColor || '#4caf50',
            color: theme.primaryColor || '#4caf50',
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding
          }}
          asChild
        >
          <Link to="/forgot-password">Reinvia email</Link>
        </Button>
      </div>
    </div>
  );
};

export default InvalidResetLink;
